// These options mirror the tool's validation and toolsettings-options
export const LTV_OPTIONS = [
  { label: 'NHG', value: true },
  { label: '60%', value: 60},
  { label: '70%', value: 70},
  { label: '80%', value: 80},
  { label: '90%', value: 90},
  { label: '100%', value: 100},
]